import EmailWarmupComponent from "../EmailWarmupComponent.vue";

export default [
  {
    path: "/email-warmup",
    name: "EmailWarmup",
    meta: { layout: "default", requiresRole: [1] },
    component: EmailWarmupComponent,
  },
];
